module.exports = __webpack_public_path__ + "img/logo1.ad0e7c7b.webp";